import React, { ReactNode } from "react";

import { GridHeader, InfoBlock } from "../../components/headers/GridHeader/GridHeader";
import styles from "./SectionWrapper.module.scss";

interface Props {
  children: ReactNode;
  headerTitle: string;
  infoBlocks: InfoBlock[];
}

export const SectionWrapper = ({ children, headerTitle, infoBlocks }: Props) => (
  <section className={styles.details__wrapper}>
    <GridHeader infoBlocks={infoBlocks} headerTitle={headerTitle} />
    <div className={styles.details__container}>{children}</div>
  </section>
);
